import React from 'react';

// function newLink(link) {
//   return link.toLowerCase().replace(/\s+/g, '-');
// }

const FooterLinksColumn = ({ title, link }) => {

  return (
    <div>
      <h4 className={`text-sm md:text-base font-medium uppercase mb-4 md:mb-6 text-white`}>
        <a href={link} className="block hover:opacity-70 text-xs md:text-sm text-white" >{title}</a>
      </h4>
      {/* <div className="space-y-2 md:space-y-3">
        {links.map((link, i) => (
          <a key={i} href={newLink(link)} className={`block hover:opacity-70 text-xs md:text-sm ${textColor}`}>
            {link}
          </a>
        ))}
      </div> */}
    </div>
  );
};

export default FooterLinksColumn;